/*
 * @Author: your name
 * @Date: 2020-04-08 14:00:49
 * @LastEditTime: 2020-04-08 18:40:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \edu_admin\src\main.js
 */
import Vue from 'vue'
import App from './App'
import router from './router'
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
    // chrome
    document.body.scrollTop = 0
        // firefox
    document.documentElement.scrollTop = 0
        // safari
    window.pageYOffset = 0
        // console.log("路由跳转")
        // $(".v-modal").style.zIndex = "30 !important"

});




import Vuex from 'vuex'
Vue.use(Vuex);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//题库题型
import questype from './assets/js/questype'
Vue.use(questype);

import axios from 'axios'
Vue.prototype.$axios = axios;

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

import VueQriously from 'vue-qriously';
Vue.use(VueQriously);

import "./assets/css/commint.css"

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

//加密方法
import requshare from './assets/js/requshare'
Vue.use(requshare);

import Base64 from './assets/js/base64'

//流量到期
import livecon from './assets/js/livecon'
Vue.use(livecon);

Vue.config.productionTip = false





// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts



/* eslint-disable no-new */
var admin = sessionStorage.getItem('admin');
if (admin) {
    axios.defaults.headers.common['admin'] = admin;
} else {
    axios.defaults.headers.common['admin'] = '';
}

var appid = sessionStorage.getItem('appid');
if (appid) {
    axios.defaults.headers.common['appid'] = appid;
} else {
    axios.defaults.headers.common['appid'] = '';
}

axios.defaults.headers.common['version'] = 'v1';
axios.defaults.headers.common['fromsource'] = 6;
axios.defaults.headers.common['device'] = 'ADMIN';
axios.defaults.withCredentials = true;

export const Module = {
    state: {
        // 正式图片
        img_url: '', //图片前缀

        // 正式,
        p_url: process.env.VUE_APP_BASE_API, //接口地址前缀
        pushurl: '',
        jikaoappid: '',
        copyappid: '',


        headerappid: {
            appid: window.sessionStorage.getItem('appid'),
        }
    },
}

Vue.filter('dataTime', function(value) {
    var theTime = parseInt(value); // 秒
    var theTime1 = '00'; // 分
    var theTime2 = '00'; // 小时
    if (theTime > 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (Number(theTime1) > 60) {
            theTime2 = parseInt(Number(theTime1) / 60);
            theTime1 = parseInt(Number(theTime1) % 60);
        }
        if (Number(theTime1) < 10) {
            theTime1 = '0' + theTime1
        }
    }
    if (Number(theTime) < 10) {
        theTime = '0' + theTime
    }

    return theTime2 + ':' + theTime1 + ':' + theTime;
})


Vue.filter('dataname', function(value) {
    if (Number(value.length) >= 15) {
        var retule = value.slice(0, 15) + '...';
    } else {
        var retule = value;
    }
    return retule;
})
const store = new Vuex.Store(Module);
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js